import React from 'react';
import MapboxHelpTooltip from '../component/MapboxHelpTooltip.jsx';
import Select from "../../../../common/Select.jsx";
import { ANIMATION_PROPS, ANIMATION_COMMON_PROPS } from './animation_const.js';
import CoordinateInput from '../component/CoordinateInput.jsx';
import { MAP_PROPS } from '../map/MapSetting.jsx';
const CommonSetting = ({updateField, animationField, fieldName}) => {
    const { zoom, center }= ANIMATION_COMMON_PROPS;
    return (
        <>
            <CoordinateInput
                base_name={`${fieldName}.center`} 
                value={animationField.center} 
                updateField={updateField} 
                title={center.title}
                description={center.description}
            />
            <label className="col-xs-12 col-md-12">
            {zoom.title}
            <Select
                value={animationField.zoom}
                options={MAP_PROPS.zoom.options}
                onChange={(v) => updateField(`${fieldName}.zoom`, v)}
            />
            </label>
        </>
    )
}

const FlyToSetting = ({updateField, animationField, index}) => {
    const flyToDuration = ANIMATION_PROPS.flyTo.duration
    const flyToVal = animationField.flyTo || {}
    return (
        <>
            <CommonSetting updateField={updateField} animationField={flyToVal} fieldName={`animationFields.${index}.flyTo`} />
            <label className="col-xs-12 col-md-12">
                {flyToDuration.title}
                <MapboxHelpTooltip description={flyToDuration.description} />
                <input
                    value={flyToVal.duration}
                    type='number'
                    data-index={index}
                    className='form-control'
                    onChange={(e) => updateField(`animationFields.${index}.flyTo.duration`, e.target.value)}
                />
            </label>
        </>
    )
}

const JumpToSetting = ({updateField, animationField, index}) => {
    return (
        <>
            <CommonSetting updateField={updateField} animationField={animationField.jumpTo || {}} fieldName={`animationFields.${index}.jumpTo`} />
        </>
    )
}

const RotateToSetting = ({updateField, animationField, index}) => {
    const {duration, pitch, bearing} = ANIMATION_PROPS.rotateTo
    const rotateToVal = animationField.rotateTo || {}
    return (
        <>
            <CommonSetting updateField={updateField} animationField={rotateToVal} fieldName={`animationFields.${index}.rotateTo`} />
            <label className="col-xs-12 col-md-12">
                {bearing.title}
                <MapboxHelpTooltip description={bearing.description} />
                <input
                    value={rotateToVal.bearing}
                    type='number'
                    data-index={index}
                    className='form-control'
                    onChange={(e) => updateField(`animationFields.${index}.rotateTo.bearing`, e.target.value)}
                />
            </label>
            <label className="col-xs-12 col-md-12">
                {duration.title}
                <MapboxHelpTooltip description={duration.description} />
                <input
                    value={rotateToVal.duration}
                    type='number'
                    data-index={index}
                    className='form-control'
                    onChange={(e) => updateField(`animationFields.${index}.rotateTo.duration`, e.target.value)}
                />
            </label>
            <label className="col-xs-12 col-md-12">
                {pitch.title}
                <MapboxHelpTooltip description={pitch.description} />
                <input
                    value={rotateToVal.pitch}
                    type='number'
                    data-index={index}
                    className='form-control'
                    min={pitch.min}
                    max={pitch.max}
                    onChange={(e) => updateField(`animationFields.${index}.rotateTo.pitch`, e.target.value)}
                />
            </label>
        </>
    )
}

const EaseToSetting = ({updateField, animationField, index}) => {
    const easeToDuration = ANIMATION_PROPS.easeTo.duration
    const easeToVal = animationField.easeTo || {}
    return (
        <>
            <CommonSetting updateField={updateField} animationField={easeToVal} fieldName={`animationFields.${index}.easeTo`} />
            <label className="col-xs-12 col-md-12">
                {easeToDuration.title}
                <MapboxHelpTooltip description={easeToDuration.description} />
                <input
                    value={easeToVal.duration}
                    type='number'
                    data-index={index}
                    className='form-control'
                    onChange={(e) => updateField(`animationFields.${index}.easeTo.duration`, e.target.value)}
                />
            </label>
        </>
    )
}

const ANIMATION_TYPE_MAPPING = {
    flyTo: (updateField, animationField, index) => {return <FlyToSetting updateField={updateField} animationField={animationField} index={index} />},
    jumpTo: (updateField, animationField, index) => {return <JumpToSetting updateField={updateField} animationField={animationField} index={index} />},
    rotateTo: (updateField, animationField, index) => {return <RotateToSetting updateField={updateField} animationField={animationField} index={index} />},
    easeTo: (updateField, animationField, index) => {return <EaseToSetting updateField={updateField} animationField={animationField} index={index} />}
}

const AnimationTypeSetting = ({animationField, updateField, index}) => {
    return ANIMATION_TYPE_MAPPING[animationField['type']](updateField, animationField, index) || null 
}

export default AnimationTypeSetting;